import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getPayrollReportConfigs = ({ groupId, reportName }) =>
  call(websocketFetch, 'get_group_payroll_report_configs', {
    group_id: groupId,
    report_name: reportName,
  });
